import { useStore } from '@nanostores/react';
import { atom } from 'nanostores';

export const $inRNWebView = atom<boolean>(false);
export const $isEmbedded = atom<boolean>(false);

export const useInRNWebView = () => useStore($inRNWebView);
export const useIsEmbedded = () => useStore($isEmbedded);
